import React from 'react'
import { Element } from 'react-bulma-components'
import Message, { CommonMessageProps } from '../../message/message'
import { WorkersRequestPost } from '../../../api/workers-requests'
import {
  WorkersRequestIcon,
  WorkersRequestPostClosedIcon,
  WorkersRequestPostEmptyIcon,
} from '../../icons'

const WorkersRequestPostIsOpened: React.FC<
  CommonMessageProps & {
    post: {
      missions: WorkersRequestPost['missions']
      isReplaceable: WorkersRequestPost['isReplaceable']
    }
  }
> = ({ post, ...rest }) => {
  if (!post) return <></>
  if (post.isReplaceable === false) return <></>
  return (
    <Message
      data-test="workers-request-post-is-opened"
      iconColor="warning"
      text="Demande en cours"
      icon={<WorkersRequestIcon />}
      {...rest}
    />
  )
}

const WorkersRequestPostIsClosed: React.FC<
  CommonMessageProps & {
    post: {
      missions: WorkersRequestPost['missions']
      isReplaceable: WorkersRequestPost['isReplaceable']
    }
  }
> = ({ post, ...rest }) => {
  if (!post) return <></>
  if (post.isReplaceable === true) return <></>
  return (
    <Message
      data-test="workers-request-post-is-closed"
      iconColor="primary"
      text="Poste fermé"
      icon={<WorkersRequestPostClosedIcon />}
      {...rest}
    />
  )
}

interface WorkersRequestPostsMessagesProps extends CommonMessageProps {
  post: WorkersRequestPost
}

const WorkersRequestPostMessages: React.FC<WorkersRequestPostsMessagesProps> = props => {
  if (!props.post) return <></>
  return (
    <Element display="flex" flexWrap="wrap">
      <WorkersRequestPostIsOpened {...props} />
      <WorkersRequestPostIsClosed {...props} />
    </Element>
  )
}

export default WorkersRequestPostMessages
